import { Component, OnInit } from '@angular/core';
import { SelectionGenericService } from './services/selection-generic.service';
import { ActivatedRoute } from '@angular/router';
import { SharedService } from '../common/services/shared-service';

@Component({
    selector: 'app-selection-generic',
    templateUrl: './selection-generic.component.html',
    styleUrls: ['./selection-generic.component.scss'],
    standalone: false
})
export class SelectionGenericComponent implements OnInit {

  selectedMenuId: number = 0;
  selectionListPanelSize: string = "70";
  selectionDetailPanelVisibility: boolean = false;
  panelSize: string = "30";

  constructor(
    public selectionService: SelectionGenericService,
    public route: ActivatedRoute,
    public sharedService: SharedService) {
    this.selectedMenuId = Number(this.route.snapshot.paramMap.get('selectedId'));
    this.subsribeEvents();
  }
 
  ngOnInit() {
    this.selectionService.initData();
  }

  subsribeEvents() {
    this.selectionService.showSidePanelEmitter.subscribe((res) => {
      this.selectionListPanelSize = res ? "70" : "100";
      this.selectionDetailPanelVisibility = res ? true : false;
      this.panelSize = res ? "30" : "0";
    })
  }
}
